import { render } from "./DropdownNotifications.vue?vue&type=template&id=6d108574"
import script from "./DropdownNotifications.vue?vue&type=script&lang=js"
export * from "./DropdownNotifications.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__